module.exports = __webpack_public_path__ + "img/12.922249e2.jpg";